<template>
  <section class="p-article4">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="cm-width c-pb-164 news-wrap">
        <section class="news-left">
          <div>
            <p class="c-fs-24 c-fw-b">第五届Zabbix峰会 中国深圳</p>
            <div class="c-mt-12 c-fs-16 c-c-text-grey">
              <span>2020-09-25 10:30</span><span class="c-ml-28">作者：猫维</span>
            </div>
          </div>
          <div class="c-mt-24 c-lh-30 c-ta-j  content-wrap">
            <p>2020年9月25日，QUAEE高颐和Zabbix在中国深圳举办的第五届Zabbix峰会上会面，Zabbix是世界级知名开源厂商，本次大会更是集结了国内知名的监控专家、运维主管、行业精英和众多Zabbix的开发和使用爱好者们，【Zabbix创始人兼CEO Alexei和高颐科技领导共同出席了本次大会。】</p>
            <p>峰会上，高颐科技领导带领公司的技术团队以Zabbix中国重要合作伙伴以及铂金会员的身份受邀参会，在会议期间与Zabbix创始人进行了深入的沟通，【就如何发挥Zabbix开源系统在中国行业客户的广泛应用做了深入的探讨，同时高颐科技通过资深Zabbix的实践总结出了丰富的经验，作为开源系统的倡导者，高颐科技也会对Zabbix开源系统贡献自己的项目成果，并会提交给Zabbix开源系统。同时双方一致确认，作为Zabbix中国区重要合作伙伴，高颐科技结合当前重要的前沿技术，人工智能AI 结合大数据的应用，为中国用户提供Zabbix的智能运维解决方案。】</p>
            <p>高颐科技技术总监在会上做了精彩演讲，把高颐科技的猫维智能运维平台服务于行业大客户的智能运维上的技术分享给前来参会的厂商和Zabbix爱好者们，详细介绍了【猫维产品在大规模运维服务上的实践经验，通过优化Zabbix的系统架构，如何适应超过十万台服务器的大规模监控的环境需求，提出了自己非常有价值的实践经验，得到了Zabbix原厂与参会者的一致认可和好评。】</p>
            <p>Zabbix SIA是一家总部位于拉脱维亚里加的软件公司，专注于IT基础架构监控与运维领域20年，是目前国际上在该领域最著名、应用最广泛的开源软件开发及服务供应商。Zabbix进入中国后，其可靠的系统架构，丰富的监控功能，被众多行业客户，如金融、能源、政企等行业大客户广泛采用。</p>
            <p>高颐科技作为一家专注为客户提供IT 智能运维软件、咨询及服务为一体的高新技术企业，将以高颐科技的核心技术团队所积累的（年限）的超大互联网的运维经验，与Zabbix系统紧密结合，为中国重要的行业客户，提供更加完善和可靠的智能监控系统，在智能监控方面共同探索，进一步发挥优势、整合资源、实现互利共赢。</p>
          </div>
          <div>
            <img src="../../assets/news/article4-1.jpg" class="c-mt-24 c-w-100">
            <img src="../../assets/news/article4-3.jpg" class="c-mt-24 c-w-100">
            <img src="../../assets/news/article4-2.jpg" class="c-mt-24 c-w-100">
            <img src="../../assets/news/article4-4.jpg" class="c-mt-24 c-w-100">
            <img src="../../assets/news/article4-5.png" class="c-mt-24 c-w-100">
            <img src="../../assets/news/article4-6.png" class="c-mt-24 c-w-100">
          </div>
        </section>
        <section class="news-right">
          <p class="c-fs-16 c-mb-16 c-fw-b">精选内容</p>
          <div>
            <p v-for="(item, index) in recommendList" :key="index" class="c-fs-12 c-cs-p c-mb-8 c-c-text-black c-ellipsis-1 news-link" @click="toUrl(item.url)">{{index + 1}}、{{item.title}}</p>
          </div>
          <div class="c-mt-48 c-mb-24 c-fs-12 c-c-text-black">
            <p class="c-fs-16 c-c-text-color c-mb-16 c-fw-b">联系我们</p>
            <p class="c-mb-8">安徽高颐科技有限公司</p>
            <p class="c-mb-8">地址：安徽省池州经济技术开发区电子信息产业园7楼</p>
            <p class="c-mb-8">电话：4006-111-696</p>
            <p>邮箱：joshua#quaee.com</p>
          </div>
          <img src="../../assets/header/QR-code1.png" class="code">
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width c-pb-40 news-wrap-mobile">
        <section class="news-left">
          <div>
            <p class="c-fs-19 c-fw-b">第五届Zabbix峰会 中国深圳</p>
            <div class="c-mt-12 c-fs-12 c-c-text-grey">
              <span>2020-09-25 10:30</span><span class="c-ml-28">作者：猫维</span>
            </div>
          </div>
          <div class="c-mt-24 c-fs-12 c-lh-18 c-ta-j  content-wrap">
            <p>2020年9月25日，QUAEE高颐和Zabbix在中国深圳举办的第五届Zabbix峰会上会面，Zabbix是世界级知名开源厂商，本次大会更是集结了国内知名的监控专家、运维主管、行业精英和众多Zabbix的开发和使用爱好者们，【Zabbix创始人兼CEO Alexei和高颐科技领导共同出席了本次大会。】</p>
            <p>峰会上，高颐科技领导带领公司的技术团队以Zabbix中国重要合作伙伴以及铂金会员的身份受邀参会，在会议期间与Zabbix创始人进行了深入的沟通，【就如何发挥Zabbix开源系统在中国行业客户的广泛应用做了深入的探讨，同时高颐科技通过资深Zabbix的实践总结出了丰富的经验，作为开源系统的倡导者，高颐科技也会对Zabbix开源系统贡献自己的项目成果，并会提交给Zabbix开源系统。同时双方一致确认，作为Zabbix中国区重要合作伙伴，高颐科技结合当前重要的前沿技术，人工智能AI 结合大数据的应用，为中国用户提供Zabbix的智能运维解决方案。】</p>
            <p>高颐科技技术总监在会上做了精彩演讲，把高颐科技的猫维智能运维平台服务于行业大客户的智能运维上的技术分享给前来参会的厂商和Zabbix爱好者们，详细介绍了【猫维产品在大规模运维服务上的实践经验，通过优化Zabbix的系统架构，如何适应超过十万台服务器的大规模监控的环境需求，提出了自己非常有价值的实践经验，得到了Zabbix原厂与参会者的一致认可和好评。】</p>
            <p>Zabbix SIA是一家总部位于拉脱维亚里加的软件公司，专注于IT基础架构监控与运维领域20年，是目前国际上在该领域最著名、应用最广泛的开源软件开发及服务供应商。Zabbix进入中国后，其可靠的系统架构，丰富的监控功能，被众多行业客户，如金融、能源、政企等行业大客户广泛采用。</p>
            <p>高颐科技作为一家专注为客户提供IT 智能运维软件、咨询及服务为一体的高新技术企业，将以高颐科技的核心技术团队所积累的（年限）的超大互联网的运维经验，与Zabbix系统紧密结合，为中国重要的行业客户，提供更加完善和可靠的智能监控系统，在智能监控方面共同探索，进一步发挥优势、整合资源、实现互利共赢。</p>
          </div>
          <div>
            <img src="../../assets/news/article4-1.jpg" class="c-mt-24 c-w-100">
            <img src="../../assets/news/article4-3.jpg" class="c-mt-24 c-w-100">
            <img src="../../assets/news/article4-2.jpg" class="c-mt-24 c-w-100">
            <img src="../../assets/news/article4-4.jpg" class="c-mt-24 c-w-100">
            <img src="../../assets/news/article4-5.png" class="c-mt-24 c-w-100">
            <img src="../../assets/news/article4-6.png" class="c-mt-24 c-w-100">
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
const recommendList = [{
  title: '第五届Zabbix峰会 中国深圳',
  url: '/article4'
}, {
  title: 'QUAEE高颐和Zabbix达成战略合作 成为Zabbix中国区重要合作伙伴',
  url: '/article1'
}, {
  title: 'Grafana如何助力Zabbix，打造漂亮的监控界面？',
  url: '/article2'
}
// {
//   title: '第五届Zabbix峰会 中国站',
//   url: '/article3'
// }
]
export default {
  data () {
    return {
      recommendList: recommendList
    }
  },
  methods: {
    toUrl (url) {
      if (url) {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style lang="scss">
.p-article4 {
  .news-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 80px;
    .news-left {
      width: 70%;
      .content-wrap {
        p {
          margin-bottom: 26px;
        }
      }
    }
    .news-right {
      width: 26%;
      .news-link {
        &:hover {
          color: $text-blue;
        }
      }
      .code {
        width: 160px;
      }
    }
  }
  .news-wrap-mobile {
    .news-left {
      width: 100%;
      margin-top: 40px;
      .content-wrap {
        p {
          margin-bottom: 14px;
        }
      }
    }
  }
}
</style>
